import { LocalDateTime } from "@js-joda/core";
import React from "react";
import { CHECK_SVG } from "../utils/svgs";
import ClockHour from "./ClockHour";
import { AppButton } from "./Generic/AppButton";
import { AppIcon } from "./Generic/AppIcon";
import { IsDefined } from "./Generic/IsDefined";

type Props = {
  manualClockTimeEditApproved: boolean;
  clockOutDateTime: LocalDateTime | null;
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
};

const ClockedOutButton: React.FC<Props> = ({
  manualClockTimeEditApproved,
  clockOutDateTime,
  onClick,
}) => {
  return (
    <AppButton variant="soft" size="small" onClick={onClick} className="ClockButton In Complete">
      {manualClockTimeEditApproved ? <AppIcon icon={CHECK_SVG} size={10} /> : null}
      <IsDefined value={clockOutDateTime}>{(x) => <ClockHour dateTime={x} />}</IsDefined>
    </AppButton>
  );
};

export default ClockedOutButton;
